import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-hk-signup",
  "use": "icon-soc-hk-signup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-hk-signup\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<path d=\"M288 160h320l160 160v544H288V160z\" /><path d=\"M608 160v160h160\" fill=\"#fff\" fill-opacity=\".35\" /><path d=\"M352 480h224v48H352zM352 576h160v48H352z\" fill=\"#fff\" /><circle cx=\"256\" cy=\"224\" r=\"40\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-hk-signup.svg
// module id = KPcn
// module chunks = 546